import { handleActions } from 'redux-actions'
import { getReadonlyContentFormSuccess } from '@tabeeb/shared/content/actions'
import * as rawActions from '../actions'

const defaultState: boolean = false

export default handleActions(
  {
    [rawActions.getFormControls.request.toString()](state, action) {
      return true
    },
    [rawActions.setFormAnswersLoading.toString()](state, action) {
      return action.payload
    },
    [rawActions.setFormAnswers.toString()](state, action) {
      return defaultState
    },
    [rawActions.getContentForm.success.toString()](state, action) {
      return defaultState
    },
    [rawActions.startLoadingFormAnswers.toString()]() {
      return true
    },
    [getReadonlyContentFormSuccess.toString()]() {
      return defaultState
    },
    [rawActions.resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
